<template>
  <div class="works-detail" v-show="isShow">
    <div class="left-right-content clearfix">
      <div class="c-left">
        <div class="article-top-info">
          <div class="art-top-title">{{ archive.archiveTitle }}</div>
          <!--          <div class="type-tags">-->
          <!--            <span class="type">动画</span>-->
          <!--            <span class="tag">#标签一#</span>-->
          <!--            <span class="tag">#标签一#</span>-->
          <!--            <span class="tag">#标签一#</span>-->
          <!--            <span class="tag">#标签一#</span>-->
          <!--          </div>-->
          <div class="zc-count clearfix">
            <i class="icon see"></i
            ><span class="much">{{ archive.viewCount }}</span>
            <i class="icon pinglun"></i
            ><span class="much">{{ archive.commentCount }}</span>
            <i class="icon fenxiang"></i
            ><span class="much">{{ archive.shareCount }}</span>
            <!-- <span class="much"><i class="el-icon-more"></i></span> -->
            <span class="tips" v-if="archive.isOriginal == 1"
              ><i class="el-icon-warning"></i> 未经作者授权，禁止转载</span
            >
            <span class="date">{{ archive.createTime | formatTime }}</span>
          </div>
        </div>

        <div class="article-center-cont" v-html="archive.archiveContent"></div>

        <!--<div class="article-center-cont" >-->
        <!--<div class="remoteHtml" v-html="archive.archiveDescription">-->

        <!--</div>-->
        <!--</div>-->

        <div class="articled-zan-cai">
          <div class="item" :class="{ active: archive.likeFlag }">
            <i class="icon zan"></i>
            <span>{{ archive.likeCount }}</span>
          </div>
          <div class="item" :class="{ active: archive.disLikeFlag }">
            <i class="icon cai"></i>
            <span>{{ archive.dislikeCount }}</span>
          </div>
        </div>
        <div
          class="pro-work-item clearfix"
          style="border-top: 5px solid #f6f6f6;"
        >
          <div class="item-infoes same-left">
            <talkPart
              :objType="2"
              :objId="objId"
              v-if="isReload"
              :loadShow="false"
              :isProView="true"
              :isShowCreateTime="false"
            ></talkPart>
          </div>
        </div>
      </div>

      <div class="c-right">
        <div class="one-item">
          <div class="detail-userinfo">
            <router-link
              :to="{ path: '/home', query: { userId: userInfo.userId } }"
              class="avatar-f"
              ><img :src="userInfo.imgUrl" alt=""
            /></router-link>
            <div class="user-name">
              <router-link
                :to="{ path: '/home', query: { userId: userInfo.userId } }"
                >{{ userInfo.userName }}</router-link
              >
            </div>
            <div class="chenghao">{{ userInfo.signature }}</div>
            <div class="qianming">{{ userInfo.introduction }}</div>
            <div class="btns" v-if="isLogin && userInfo.userId != loginUserId">
              <el-button
                class="btn wgz-btn"
                v-if="userInfo.followStatus == 0"
                @click="doFollow(userInfo.userId)"
                ><i class="el-icon-plus"></i> 关注</el-button
              >
              <el-button
                class="btn"
                v-else-if="userInfo.followStatus == 1"
                @click="undoFollower(userInfo.userId)"
                >已关注</el-button
              >
              <el-button
                class="btn"
                v-else-if="userInfo.followStatus == 2"
                @click="undoFollower(userInfo.userId)"
                >互相关注</el-button
              >

              <el-button
                class="btn wgz-btn"
                v-if="friendStatus == 4"
                @click="addFriend()"
                ><i class="el-icon-plus"></i> 加好友</el-button
              >
              <!--<el-button
                class="btn"
                @click="toChart(userInfo.userId)"
                v-else-if="friendStatus == 2"
                >发消息</el-button
              >-->
              <el-button
                class="btn"
                v-else-if="friendStatus == 1"
                style="cursor:auto"
                >请求中</el-button
              >
            </div>
            <ul class="much-list three clearfix">
              <li>
                <span class="tit">文章</span>
                <span class="count">{{ userInfo.archivesCount }}</span>
              </li>
              <li>
                <span class="tit">阅读</span>
                <span class="count">{{ userInfo.viewCount }}</span>
              </li>
              <li>
                <span class="tit">被赞</span>
                <span class="count">{{ userInfo.likeCount }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="one-item">
          <div class="one-title">
            其他文章
            <i class="el-icon-refresh-right shuaxin" @click="other"></i>
          </div>
          <ul class="articles-list">
            <li v-for="(item, index) in otherArchiveList" :key="index">
              <div class="art-tit">
                <router-link
                  :to="{ path: '/column/themedetail', query: { id: item.id } }"
                  target="_blank"
                  :title="item.archiveTitle"
                  >{{ item.archiveTitle }}
                </router-link>
              </div>
              <span class="date">{{ item.createTimeStr }}</span>
            </li>
          </ul>
        </div>

        <div class="one-item">
          <div class="one-title">
            其他专题
            <i class="el-icon-refresh-right shuaxin" @click="otherColumn"></i>
          </div>
          <ul class="articles-list">
            <li v-for="(item, index) in otherColumnList" :key="index">
              <div class="art-tit">
                <router-link
                  :to="{ path: '/column/themedetail', query: { id: item.id } }"
                  target="_blank"
                  :title="item.archiveTitle"
                  >{{ item.archiveTitle }}
                </router-link>
              </div>
              <span class="date">{{ item.createTimeStr }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import archiveApi from '@/api/archive'
import userInfoApi from '@/api/userInfo'
import talkPart from '@@/pub/talkpart/talkpart'
import homeApi from '@/api/home'
import apiService from '@/api/index'

export default {
    components: {
        talkPart
    },
    data () {
        return {
            friendStatus:-1,
            otherTotal:0,
            otherColumnTotal:0,
            isShow:false,
            isLogin: false,
            loginUserId:0,
            objId:0,
            isReload:true,
            showData:[],
            textCon: '',
            activitiesAnd: false,
            archive:{
                archiveTitle:'',
                archiveContent:'',
                archiveDescription:"",
                viewCount:0,
                commentCount:0,
                likeCount:0,
                dislikeCount:0,
                shareCount:0,
                creatorId:0,

            },
            otherArchivesParam:{
                creatorId:0,
                id:0,
                pageIndex: 1,
                pageSize: 4,
                publishStatus:1,
                columnType:2,
                orderType:'other'
            },
            otherArchiveList:[],
            otherColumnParam:{
                creatorId:0,
                id:0,
                pageIndex: 1,
                pageSize: 4,
                publishStatus:1,
                columnType:2,
                otherColumnId:0,
                orderType:'other'
            },
            otherColumnList:[],
            userInfo:{},
        }
    },
    beforeMount(){
        let id = this.$route.query.id
        if(id){
            this.objId =parseInt(id)
        }

    },
    mounted(){

        setTimeout( () =>{
          if(!this.global.isLogin){
            this.$message.error("未登录")
            return
          }

          this.initData()
        },500)


    },
    methods:{
        initData(){
            let this_  = this
            let id = this_.$route.query.id
            if(this.global.isLogin){
                this_.loginUserId = this.global.userModel.id
                this_.isLogin = true
            }
            if(id && parseInt(id) !== 0){
                archiveApi.select(id).then(re => {

                    if(re.code == -1 || re.response.deleteFlag==1){
                        this.$router.push({
                            path:'/error',
                        })
                    }
                    // else if(re.response.publishStatus==0){
                    //     //修改审核中
                    //     this.$message.error("文章修改审核中")
                    // }
                    else{

                        archiveApi.updateCountNum(id).then(r => {

                        })
                        this_.isShow = true


                        this_.archive = re.response

                        console.log(this_.archive)
                        //作者信息
                        userInfoApi.select(this_.archive.creatorId).then(reUser => {
                            this_.userInfo = reUser.response
                        })
                        //其他文章
                        this_.other()
                        //其他专题
                        this_.otherColumn()

                        this_.setHead()
                        this_.getFriendStatus()
                    }

                })
            }else{
                this.$router.push({
                    path:'/error',
                })
                console.log("ERROR FOR ID")
            }
        },
        doFollow(userId){
            let this_ = this
            homeApi.follower(userId).then(data => {
                // console.log(data)
                const status = data.response.status
                if (status >= 1) {
                    this_.userInfo.followStatus=status
                    this_.$message.success("关注成功")
                } else {
                    this_.$message.error("关注失败")
                }
            })
        },
        undoFollower(userId) {
            let _this = this;
            homeApi.undoFollower(userId).then(data => {
                // console.log(data)
                const status = data.response.status
                if (status == 1) {
                    _this.userInfo.followStatus=0
                    _this.$message.success("取消成功")
                } else {
                    _this.$message.error("取消失败")
                }
            })
        },
        other(){
            console.log('other')
            let this_ = this
            this_.otherArchivesParam.creatorId =this_.archive.creatorId
            this_.otherArchivesParam.id = this_.archive.id

            archiveApi.getOtherList(this_.otherArchivesParam).then(reOther => {
                this_.otherArchiveList= reOther.list

                this_.otherTotal= reOther.total
                if(this_.otherArchivesParam.pageIndex == Math.ceil(this_.otherTotal/this_.otherArchivesParam.pageSize) ){
                    this_.otherArchivesParam.pageIndex =1
                }else{
                    this_.otherArchivesParam.pageIndex = this_.otherArchivesParam.pageIndex+1
                }
            })
        },
        otherColumn(){
            console.log('otherotherColumn')
            let this_ = this
            this_.otherColumnParam.creatorId =this_.archive.creatorId
            this_.otherColumnParam.id = this_.archive.id

            archiveApi.getOtherList(this_.otherColumnParam).then(reOther => {
                this_.otherColumnList= reOther.list

                this_.otherColumnTotal= reOther.total
                if(this_.otherColumnParam.pageIndex == Math.ceil(this_.otherColumnTotal/this_.otherColumnParam.pageSize) ){
                    this_.otherColumnParam.pageIndex =1
                }else{
                    this_.otherColumnParam.pageIndex = this_.otherColumnParam.pageIndex+1
                }
            })
        },
        likeEvent(id,belongSection){
            console.debug(id);
            var _this =this;
            console.debug(_this.isLogin);
            if(_this.isLogin){
                apiService.dolike({"objectType":2,"objectId":id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
                    console.log(data)
                    _this.initData();
                    // 重新渲染组件
                    _this.reloadModel()
                })
            }else{
                // _this.$message({
                //     message: '您尚未登录,请登录后操作',
                //     type: 'error'
                // });
                _this.toLog()
            }

        },
        disLikeEvent(id,belongSection){
            console.debug(id);
            var _this =this;
            if(_this.isLogin) {
                apiService.dislike({"objectType": 2, "objectId": id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
                    console.log(data)
                    _this.initData();
                    // 重新渲染组件
                    _this.reloadModel()
                })
            }else{
                // _this.$message({
                //     message: '您尚未登录,请登录后操作',
                //     type: 'error'
                // });
                _this.toLog()
            }
        },
        reloadModel(){
            let _this = this
            // 移除组件
            _this.isReload = false
            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            _this.$nextTick(() => {
                _this.isReload = true
            })
        },
        toLog(){
            this.$router.push({
                path:'/login?callback=' + window.location.href,
            })

        } ,
        setHead(){
            document.title = this.archive.archiveTitle+"——人人动画网【官网】"
            document.querySelector('meta[name="keywords"]').setAttribute('content', this.archive.columnTypeStr)

            let desc = this.archive.archiveContent.replace(/<\/?.+?>/g,"").trim()
            document.querySelector('meta[name="description"]').setAttribute('content', desc.substr(0,150))
        },
        getFriendStatus(){
            let _this=this;
            let url="/rrbi/friends/getFriendStatus?userId="+_this.archive.creatorId+"&currentUserId="+_this.loginUserId+"&ti="+new Date().getMilliseconds();
            _this.$axios.get(url).then(function(result){
                _this.friendStatus = result.data
            })
        },
        addFriend() {
            let _this = this;
            if (_this.global.isLogin) {
                let url = '/rrbi/friends/add/' + _this.archive.creatorId + "?ti=" + new Date().getMilliseconds();
                _this.$axios.get(url).then(function (result) {
                    console.log(result)
                    if (result.data.response.code == 1) {
                        _this.$message.success(result.data.response.msg)
                        _this.friendStatus = 1
                    } else {
                        _this.$message.error(result.data.response.msg)
                    }
                })
            }
        },
    }
}
</script>

<style scoped lang="less">
.works-detail {
  padding-top: @NAVHEIGHT;
  .about-works {
    padding: 10px;
    line-height: 30px;
    color: #808080;
    font-size: 16px;
    background: #f6f6f6;
  }
}
//@import "../../../assets/less/stylePublic.less";
</style>
